const getPlacementFromPlacements = (response, targetPlacementKey) => {
  if (!response) {
    return {};
  }

  const placements = response.placements.reduce(
    (placements, placementObject) => {
      const [placementKey, [placement]] = Object.entries(placementObject).pop();
      return Object.assign(placements, { [placementKey]: placement });
    },
    {}
  );

  const foundPlacement = placements[targetPlacementKey];

  if (foundPlacement) {
    const responseId = response["page-uid"];

    foundPlacement.responseId = responseId;

    return foundPlacement;
  }

  return {};
};

export default getPlacementFromPlacements;
